import loadable from '@loadable/component';

export default loadable(
  /* webpackChunkName: "VerifyEmailDialog" */ () =>
    import('./VerifyEmailDialogRoot'),
);
